export default __webpack_public_path__ + "static/media/2209.b5c19440.png";